import React from 'react';

import CustomerPortalAction from '../../../actions/CustomerPortalAction';

export default class PayAccountEntry extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false
    };
    this._toggleExpanded = this._toggleExpanded.bind(this);
    this._toggleCheck = this._toggleCheck.bind(this);
  }
  _toggleCheck(event){
    event.stopPropagation();
    CustomerPortalAction.updatePayAccountSelection(this.props.document.docNo);
  }
  _updateTotalCounter(event){
    let price = 0;
    let input = event.target.value;
    let currentAmt = parseFloat(this.props.document.currentAmt.replace(/[^\d.]/g, ''));
    price = parseFloat(input.replace(/[^\d.\-]/g, ''));
    if(price > 0 && price <= currentAmt){
      if(!input.startsWith(this.props.currency)){
        event.target.value = this.props.currency+" "+window.formatNum(price);
      }
      CustomerPortalAction.updatePayAccountTotal(this.props.document.docNo,price);
      this.refs.input.className = 'text-md-right form-control';
      this.refs.input.title = '';
    } else {
      this.refs.input.className = 'text-md-right form-control is-invalid '
      this.refs.input.title = 'Invalid price';
      this.refs.input.focus();
    }
  }
  _toggleExpanded(event){
    event.stopPropagation();
    this.setState({expanded:!this.state.expanded});
  }
  render(){
    return (
      <div>
        <div className='table-row clickable'  onClick={this._toggleExpanded}>
          <div className='table-cell clickable order-type' onClick={this._toggleCheck}>
             <div className='d-flex'>
                <span className="checkbox checkbox-checkbox">
                    &nbsp;
                    <input
                        type="checkbox"
                        value={this.props.value}
                        checked={this.props.document.checked||false}
                        onChange={() => { return false }}
                    />
                    <div className="checkbox_box"></div>
                </span>
                <div className='d-flex d-md-none justify-content-between ml-2 w-100'>
                    <span className='mobile title'>Pay</span>
                    <div className='btn-expand' onClick={this._toggleExpanded}> {(this.state.expanded)?("Collapse"):("Expand")}&nbsp;<i className={'fa fa-chevron-'+((this.state.expanded)?('up'):('down'))}/></div>
                </div>

             </div>
          </div>
          <div className='table-cell clickable order-cusno'>
            <span className='mobile title' data-translation="transaction.customerNo">CUSTOMER NO.</span>
            <span>{this.props.document.customerNo}</span>
          </div>
          <div className='table-cell clickable order-docno'>
            <span className='mobile title' data-translation="transaction.docNo">DOCUMENT NO.</span>
            <span className=''>{this.props.document.docNo}</span>
          </div>
          <div className='table-cell clickable order-date'>
            <span className='mobile title' data-translation="transaction.docDate">DOC DATE</span>
            <span>{this.props.document.docDate}</span>
          </div>
          <div className='table-cell clickable order-date'>
            <span className='mobile title' data-translation="transaction.dueDate">DUE DATE</span>
            <span>{this.props.document.dueDate}</span>
          </div>
          <div className='table-cell clickable order-po'>
            <span className='mobile title' data-translation="transaction.poNo">PO NO</span>
            <span>{this.props.document.poNo}</span>
          </div>
          <div className='table-cell clickable order-price'>
            <span className='mobile title' data-translation="transaction.originalAmt">ORIGINAL AMT</span>
            <span>{this.props.document.originalAmt}</span>
          </div>
          <div className='table-cell clickable order-price'>
            <span className='mobile title' data-translation="transaction.currentAmt">APPLIED</span>
            <span>{this.props.document.currentAmt}</span>
          </div>
          <div className='table-cell clickable order-price'>
            <span className='mobile title' data-translation="transaction.payAmount">PAY AMOUNT</span>
            {this.props.document.checked && this.props.allowPartialPayment?(
              <div className='div-price-input'>
                <input
                  ref='input'
                  className='text-md-right form-control'
                  defaultValue={this.props.document.currentAmt}
                  onBlur={this._updateTotalCounter.bind(this)}
                  onClick={(event)=>{event.stopPropagation()}}
                  onKeyPress = {(event)=>{ if(event.key === 'Enter'){ this.refs.input.blur(); } }}
                />
              </div>
            ):(
              <span>{this.props.document.checked ? (this.props.document.currentAmt):('$ 0.00')}</span>
            )}
          </div>
        </div>
            <div className={'gray-background item-table table sub-item-table ' + ((this.props.document.details.length>14) ? ('extra-height '):(''))+(this.state.expanded?('show'):(''))} onClick={this._toggleExpanded}>
            <div className='table-row table-header no-hover'>
              <div className='table-cell item-sku'><label data-translation="transaction.itemNo">Item No</label></div>
              <div className='table-cell item-description'><label data-translation="transaction.description">Description</label></div>
              <div className='table-cell item-price'><label data-translation="transaction.extPrice">Ext. Price</label></div>
            </div>
            {(this.props.document.details).map((item,key)=>{
              return(
                <div key={'item-row-'+key} className='table-row'>
                  <div className='table-cell item-sku'>
                  <span className='mobile title' data-translation="transaction.itemNo">Item NO</span>
                  <span className=''>{item.itemNo}</span>
                  </div>
                  <div className='table-cell item-description'>
                  <span className='mobile title' data-translation="transaction.description">DESCRIPTION</span>
                  <span className=''>{item.description}</span>
                  </div>
                  <div className='table-cell item-price'>
                  <span className='mobile title' data-translation="transaction.extPrice">Ext. Price</span>
                  <span className=''>{item.extPrice}</span>
                  </div>
                </div>
              )
            })}
        </div>
      </div>
    );
  }
}
PayAccountEntry.defaultProps = {checked: false}
